import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  getYear,
  subYears,
} from "date-fns";

import Drawer from "..";
import Typography from "../../Typography";
import DatePicker from "../../DatePicker";
import FieldContainer from "../../FieldContainer/FieldContainer";
import Button from "../../Button/Button";
import SelectTag from "../../SelectTag/SelectTag";

import { setFilterNps } from "../../../actions/npsFilters";

import * as APINps from "../../../services/nps/functions";

import { ReactComponent as CleanIcon } from "../../../build/images/icons/Clean.svg";

import "./call-center-filters.css";
import { setFilterAgentDashboard } from "../../../actions/agentDashboardFilters";
import { getAvaliations, getChannels } from "../../../actions";
import SelectTagV2 from "../../SelectTagV2/SelectTagV2";

export default function CallCenterfilters({
  screen,
  dataAdditionalFields = [],
  ...others
}) {
  const npsFilters = useSelector((state) => state.npsfilters);
  const userReducer = useSelector((state) => state.informationusers);
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const groupsReducers = useSelector(
    (state) => state.groups
  );

  const groupsFilters = groupsReducers.groups;

  groupsFilters.map(group => {
      group.label = group.name
  })

  const dispatch = useDispatch();
  const finalDateDefault = new Date();
  const initialDateDefault = new Date(
    new Date().setDate(new Date().getDate() - 30)
  );

  const [initialDate, setInitialDate] = useState(
    new Date(npsFilters.datestart)
  );
  const [finalDate, setFinalDate] = useState(new Date(npsFilters.dateend));
  const [controlActive, setControlActive] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [businessSelected, setBusinessSelected] = useState(npsFilters.business);
  const [periodSelected, setPeriodSelected] = useState(npsFilters.period);
  const [comparisonSelected, setComparisonSelected] = useState(
    npsFilters.comparison
  );
  const [unitsSelected, setUnitsSelected] = useState(npsFilters.units);
  const [periodSelectedAgentScreen, setPeriodSelectedAgentScreen] = useState(
    agentDashboardFilter.periodSelectedAgentScreen
  );
  const [profileSelectedAgenteScreen, setProfileSelectedAgenteScreen] =
    useState(agentDashboardFilter.profileSelectedAgenteScreen);
  const [channelSelectedAgentScreen, setChannelSelectedAgentScreen] = useState(
    agentDashboardFilter.channelSelectedAgentScreen
  );
  const [avaliationSelectedAgentScreen, setAvaliationSelectedAgentScreen] =
    useState(agentDashboardFilter.avaliationSelectedAgentScreen);
  const [groupSelectedAgentScreen, setGroupSelectedAgentScreen] =
    useState(agentDashboardFilter.groupSelectedAgentScreen);
  const [initialDateAgenteScreen, setInitialDateAgenteScreen] = useState(
    new Date(agentDashboardFilter.initialDateAgenteScreen)
  );
  const [finalDateAgentScreen, setFinalDateAgentScreen] = useState(
    new Date(agentDashboardFilter.finalDateAgentScreen)
  );
  const [listChannel, setListChannel] = useState([]);
  const [listAvaliations, setListAvaliations] = useState([]);
  const [initialDateYear, setInitialDateYear] = useState(
    new Date(agentDashboardFilter.initialDateYear)
  );
  const [finalDateYear, setFinalDateYear] = useState(
    new Date(agentDashboardFilter.finalDateYear)
  );

  const isAgentScreen =
    screen === "DashboardAgent" ||
    screen === "DealingAgent" ||
    screen === "RankingAgent" ||
    screen === "IndicatorsAgent";

  const listRequest = [
    { id: 1, label: "Dia" },
    { id: 2, label: "Semana" },
    { id: 3, label: "Mês" },
    { id: 4, label: "Ano" },
    { id: 5, label: "Personalizar" },
  ];

  const listComparison = [
    { id: "PROMOTOR", label: "Promotor" },
    { id: "NEUTRO", label: "Neutro" },
    { id: "DETRATOR", label: "Detrator" },
  ];

  /*
  const listAvaliations = [
    { id: 1, label: "Testando" },
    { id: 2, label: "Testando 2" },
  ];
*/
  async function getChannelsList() {
    let updatedChannelsList = [];
    const response = await getChannels();
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedChannelsList = data.map((datum) => {
          return { id: datum.id, label: datum.describer };
        });
      }
    }
    setListChannel(updatedChannelsList);
  }

  async function getAvaliationsList() {
    let updatedAvaliationsList = [];
    const response = await getAvaliations();
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedAvaliationsList = data.map((datum) => {
          return { id: datum.id, label: datum.description };
        });
      }
    }

    setListAvaliations(updatedAvaliationsList);
  }

  async function getBusinessList() {
    const response = await APINps.getBusiness();
    const hasResponse = !!response && response.status === 200;

    if (hasResponse) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setBusinessList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  async function getUnitsList() {
    const response = await APINps.getUnits();
    const hasResponse = !!response && response.status === 200;

    if (hasResponse) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setUnitsList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  function renderAgentScreeFilters() {
    const finalDateCopy = new Date(finalDateYear);
    const initialDateCopy = new Date(initialDateYear);
    const currentYear = new Date();
    const isDashboardAgent = screen === "DashboardAgent";
    const isIndicatorsAgent = screen === "IndicatorsAgent";
    const hasProfileFilter = isIndicatorsAgent;
    let typeOfDate = 5;
    if (isDashboardAgent) {
      typeOfDate = periodSelectedAgentScreen[0].id;
    }
    return (
      <div className="filters-dashboard filters-dashboard-call-center">
        {isDashboardAgent && (
          <FieldContainer title="Selecione o período" htmlFor="">
            <div className="filters-dashboard-container-tag">
              <SelectTagV2
                valueTag={periodSelectedAgentScreen}
                options={listRequest}
                onSelect={(option) => {
                  changeOptionsPeriodAgentScreen(option);
                }}
                multiple={false}
                isCallCenter={true}
                isChipActive={false}
              />
            </div>
          </FieldContainer>
        )}
        <div className="filters-dashboard-container__date-range-container">
          {changeDateInputAgentScreen(typeOfDate)}
        </div>
        {isIndicatorsAgent && (
          <div className="filters-dashboard-container__date-range-container">
            <FieldContainer
              title="Ano de resumo"
              className="case-client"
              htmlFor=""
            >
              <DatePicker.DateRange
                selected={initialDateYear}
                setDate={(event) => {
                  const newDate = event;
                  setInitialDateYear(newDate);
                }}
                selectRangeType="start"
                endDate={finalDateYear}
                maxDate={finalDateCopy.setFullYear(
                  finalDateCopy.getFullYear() - 1
                )}
                dateFormat={"yyyy"}
                showYearPicker={true}
                isIconV2={true}
              />
            </FieldContainer>

            <FieldContainer
              title="Ano a comparar"
              className="case-client"
              htmlFor=""
            >
              <DatePicker.DateRange
                selected={finalDateYear}
                setDate={(event) => {
                  const newDate = event;
                  setFinalDateYear(newDate);
                }}
                selectRangeType="end"
                startDate={initialDateYear}
                minDate={initialDateCopy.setFullYear(
                  initialDateCopy.getFullYear() + 1
                )}
                dateFormat={"yyyy"}
                ref={others.refFinalDate}
                isClearable={false}
                showYearPicker={true}
                maxDate={currentYear.setFullYear(currentYear.getFullYear())}
                isIconV2={true}
              />
            </FieldContainer>
          </div>
        )}
        {hasProfileFilter && (
          <FieldContainer title="Perfil" htmlFor="">
            <div className="filters-dashboard-container-tag">
              <SelectTagV2
                valueTag={profileSelectedAgenteScreen}
                options={listComparison}
                onSelect={(option) => {
                  changeOptionsProfileAgentScreen(option);
                }}
                multiple={false}
                isCallCenter={true}
                isChipActive={false}
              />
            </div>
          </FieldContainer>
        )}
        <FieldContainer title="Canal" htmlFor="">
          <div className="filters-dashboard-container-tag">
            <SelectTagV2
              valueTag={channelSelectedAgentScreen}
              options={listChannel}
              onSelect={(option) => {
                changeOptionsChannelAgentScreen(option);
              }}
              multiple={true}
              isCallCenter={true}
              isCloseOnSelect={false}
            />
          </div>
        </FieldContainer>
        <FieldContainer title="Tipo de avaliação" htmlFor="">
          <div className="filters-dashboard-container-tag">
            <SelectTagV2
              valueTag={avaliationSelectedAgentScreen}
              options={listAvaliations}
              onSelect={(option) => {
                changeOptionsAvaliationAgentScreen(option);
              }}
              multiple={true}
              isCallCenter={true}
              isCloseOnSelect={false}
            />
          </div>
        </FieldContainer>
        <FieldContainer title="Grupo" htmlFor="">
          <div className="filters-dashboard-container-tag">
            <SelectTagV2
              valueTag={groupSelectedAgentScreen}
              options={groupsFilters}
              onSelect={(option) => {
                changeOptionsGroupAgentScreen(option);
              }}
              multiple={true}
              isCallCenter={true}
              isCloseOnSelect={false}
            />
          </div>
        </FieldContainer>
      </div>
    );
  }

  const removeOptionBusiness = (idRemoved) => {
    let elements = arrayRemove(businessSelected, idRemoved);
    setBusinessSelected(elements);
  };

  const removeOptionPeriod = (idRemoved) => {
    let elements = arrayRemove(periodSelected, idRemoved);
    setPeriodSelected(elements);
  };

  const removeOptionComparison = (idRemoved) => {
    let elements = arrayRemove(comparisonSelected, idRemoved);
    setComparisonSelected(elements);
  };

  const removeOptionUnits = (idRemoved) => {
    let elements = arrayRemove(unitsSelected, idRemoved);
    setUnitsSelected(elements);
  };

  const removeOptionProfileAgentScreen = (idRemoved) => {
    let elements = arrayRemove(profileSelectedAgenteScreen, idRemoved);
    setProfileSelectedAgenteScreen(elements);
  };

  const removeOptionChannelAgentScreen = (idRemoved) => {
    let elements = arrayRemove(channelSelectedAgentScreen, idRemoved);
    setChannelSelectedAgentScreen(elements);
  };

  const removeOptionAvaliationAgentScreen = (idRemoved) => {
    let elements = arrayRemove(avaliationSelectedAgentScreen, idRemoved);
    setAvaliationSelectedAgentScreen(elements);
  };

  const removeOptionGroupAgentScreen = (idRemoved) => {
    let elements = arrayRemove(groupSelectedAgentScreen, idRemoved);
    setGroupSelectedAgentScreen(elements);
  };

  const changeOptionsBusiness = (option) => {
    const arrayFound = businessSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionBusiness(arrayFound.id);
    } else {
      setBusinessSelected([
        ...businessSelected,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const changeOptionsPeriod = (option) => {
    setPeriodSelected([{ id: option.id, label: option.label }]);
  };

  const changeOptionsComparison = (option) => {
    const arrayFound = comparisonSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionComparison(arrayFound.id);
    } else {
      setComparisonSelected([{ id: option.id, name: option.label }]);
    }
  };

  const changeOptionsProfileAgentScreen = (option) => {
    setProfileSelectedAgenteScreen([{ id: option.id, name: option.label }]);
  };

  const changeOptionsChannelAgentScreen = (option) => {
    const arrayFound = channelSelectedAgentScreen.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionChannelAgentScreen(arrayFound.id);
    } else {
      setChannelSelectedAgentScreen([
        ...channelSelectedAgentScreen,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const changeOptionsAvaliationAgentScreen = (option) => {
    const arrayFound = avaliationSelectedAgentScreen.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionAvaliationAgentScreen(arrayFound.id);
    } else {
      setAvaliationSelectedAgentScreen([
        ...avaliationSelectedAgentScreen,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const changeOptionsGroupAgentScreen = (option) => {
    const arrayFound = groupSelectedAgentScreen.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionGroupAgentScreen(arrayFound.id);
    } else {
      setGroupSelectedAgentScreen([
        ...groupSelectedAgentScreen,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const changeOptionsUnits = (option) => {
    const arrayFound = unitsSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionUnits(arrayFound.id);
    } else {
      setUnitsSelected([
        ...unitsSelected,
        { id: option.id, label: option.label },
      ]);
    }
  };

  const changeOptionsPeriodAgentScreen = (option) => {
    setPeriodSelectedAgentScreen([{ id: option.id, label: option.label }]);
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (elem) {
      return elem.id != value;
    });
  };

  function changeDateInput(idType) {
    if (idType === 1) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={finalDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  0,
                  0,
                  0,
                  0
                )
              );
              setFinalDate(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  23,
                  59,
                  59,
                  999
                )
              );
            }}
            selectRangeType="start"
            // endDate={finalDate}
            // maxDate={finalDate}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 2) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfWeek(newDate));
              setFinalDate(endOfWeek(newDate));
            }}
            selectRangeType="start"
            showWeekPicker={true}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 3) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfMonth(newDate));
              setFinalDate(endOfMonth(newDate));
            }}
            selectRangeType="start"
            showMonthYearPicker={true}
            dateFormat={"MMMM 'de' yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 4) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfYear(newDate));
              setFinalDate(endOfYear(newDate));
            }}
            selectRangeType="start"
            showYearPicker={true}
            dateFormat={"yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 5) {
      const finalDateCopy = new Date(finalDate);
      const initialDateCopy = new Date(initialDate);
      return (
        <>
          <FieldContainer
            title="Data início"
            className="case-client"
            htmlFor=""
          >
            <DatePicker.DateRange
              isIconV2={true}
              selected={initialDate}
              setDate={(event) => {
                const newDate = event;
                setInitialDate(newDate);
              }}
              selectRangeType="start"
              endDate={finalDate}
              maxDate={
                screen === "Comparisons"
                  ? finalDateCopy.setFullYear(finalDateCopy.getFullYear() - 1)
                  : finalDate
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>

          <FieldContainer title="Data fim" className="case-client" htmlFor="">
            <DatePicker.DateRange
              isIconV2={true}
              selected={finalDate}
              setDate={(event) => {
                const newDate = event;
                setFinalDate(newDate);
              }}
              selectRangeType="end"
              startDate={initialDate}
              minDate={
                screen === "Comparisons"
                  ? initialDateCopy.setFullYear(
                      initialDateCopy.getFullYear() + 1
                    )
                  : initialDate
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              ref={others.refFinalDate}
              isClearable={false}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>
        </>
      );
    }
  }

  function changeDateInputAgentScreen(idType) {
    if (idType === 1) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={finalDateAgentScreen}
            setDate={(event) => {
              const newDate = event;

              setInitialDateAgenteScreen(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  0,
                  0,
                  0,
                  0
                )
              );
              setFinalDateAgentScreen(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  23,
                  59,
                  59,
                  999
                )
              );
            }}
            selectRangeType="start"
            // endDate={finalDate}
            // maxDate={finalDate}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 2) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDateAgenteScreen}
            setDate={(event) => {
              const newDate = event;

              setInitialDateAgenteScreen(startOfWeek(newDate));
              setFinalDateAgentScreen(endOfWeek(newDate));
            }}
            selectRangeType="start"
            showWeekPicker={true}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 3) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDateAgenteScreen}
            setDate={(event) => {
              const newDate = event;

              setInitialDateAgenteScreen(startOfMonth(newDate));
              setFinalDateAgentScreen(endOfMonth(newDate));
            }}
            selectRangeType="start"
            showMonthYearPicker={true}
            dateFormat={"MMMM 'de' yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 4) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            isIconV2={true}
            selected={initialDateAgenteScreen}
            setDate={(event) => {
              const newDate = event;

              setInitialDateAgenteScreen(startOfYear(newDate));
              setFinalDateAgentScreen(endOfYear(newDate));
            }}
            selectRangeType="start"
            showYearPicker={true}
            dateFormat={"yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 5) {
      const finalDateCopy = new Date(finalDateAgentScreen);
      const initialDateCopy = new Date(initialDateAgenteScreen);
      return (
        <>
          <FieldContainer
            title="Data início"
            className="case-client"
            htmlFor=""
          >
            <DatePicker.DateRange
              isIconV2={true}
              selected={initialDateAgenteScreen}
              setDate={(event) => {
                const newDate = event;
                setInitialDateAgenteScreen(newDate);
              }}
              selectRangeType="start"
              endDate={finalDateAgentScreen}
              maxDate={
                screen === "Comparisons"
                  ? finalDateCopy.setFullYear(finalDateCopy.getFullYear() - 1)
                  : finalDateAgentScreen
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>

          <FieldContainer title="Data fim" className="case-client" htmlFor="">
            <DatePicker.DateRange
              isIconV2={true}
              selected={finalDateAgentScreen}
              setDate={(event) => {
                const newDate = event;
                setFinalDateAgentScreen(newDate);
              }}
              selectRangeType="end"
              startDate={initialDateAgenteScreen}
              minDate={
                screen === "Comparisons"
                  ? initialDateCopy.setFullYear(
                      initialDateCopy.getFullYear() + 1
                    )
                  : initialDateAgenteScreen
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              ref={others.refFinalDate}
              isClearable={false}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>
        </>
      );
    }
  }

  const getCasesFilterAdvanceds = () => {
    if (isAgentScreen) {
      dispatch(
        setFilterAgentDashboard(
          "periodSelectedAgentScreen",
          periodSelectedAgentScreen
        )
      );
      dispatch(
        setFilterAgentDashboard(
          "profileSelectedAgenteScreen",
          profileSelectedAgenteScreen
        )
      );
      dispatch(
        setFilterAgentDashboard(
          "channelSelectedAgentScreen",
          channelSelectedAgentScreen
        )
      );
      dispatch(
        setFilterAgentDashboard(
          "groupSelectedAgentScreen",
          groupSelectedAgentScreen
        )
      );
      dispatch(
        setFilterAgentDashboard(
          "avaliationSelectedAgentScreen",
          avaliationSelectedAgentScreen
        )
      );
      dispatch(
        setFilterAgentDashboard(
          "initialDateAgenteScreen",
          initialDateAgenteScreen
        )
      );
      dispatch(
        setFilterAgentDashboard("finalDateAgentScreen", finalDateAgentScreen)
      );
      dispatch(setFilterAgentDashboard("initialDateYear", initialDateYear));
      dispatch(setFilterAgentDashboard("finalDateYear", finalDateYear));

      window.localStorage.setItem(
        "agentDashboardFilter",
        JSON.stringify({
          periodSelectedAgentScreen,
          profileSelectedAgenteScreen,
          channelSelectedAgentScreen,
          groupSelectedAgentScreen,
          avaliationSelectedAgentScreen,
          initialDateAgenteScreen,
          finalDateAgentScreen,
          initialDateYear,
          finalDateYear,
        })
      );

      others.onClose(false);
      return;
    }

    dispatch(setFilterNps("active", true));
    dispatch(setFilterNps("business", businessSelected));
    dispatch(setFilterNps("period", periodSelected));
    dispatch(setFilterNps("comparison", comparisonSelected));
    dispatch(setFilterNps("units", unitsSelected));

    if (screen === "Comparisons") {
      dispatch(setFilterNps("datestartComparisons", initialDate));
      dispatch(setFilterNps("dateendComparisons", finalDate));
    } else {
      dispatch(setFilterNps("datestart", initialDate));
      dispatch(setFilterNps("dateend", finalDate));
    }

    others.onClose(false);
  };

  const cleanFiltersAdvanceds = () => {
    if (isAgentScreen) {
      dispatch(
        setFilterAgentDashboard("periodSelectedAgentScreen", [
          { id: 5, label: "Personalizar" },
        ])
      );
      dispatch(
        setFilterAgentDashboard("profileSelectedAgenteScreen", [
          { id: "PROMOTOR", label: "Promotor" },
        ])
      );
      dispatch(
        setFilterAgentDashboard("channelSelectedAgentScreen", [
          { id: 1, label: "Voz" },
        ])
      );
      dispatch(
        setFilterAgentDashboard("groupSelectedAgentScreen", [
          groupsFilters[0],
        ])
      );
      dispatch(
        setFilterAgentDashboard("avaliationSelectedAgentScreen", [
          { id: 1, label: "Testando" },
        ])
      );
      dispatch(
        setFilterAgentDashboard("initialDateAgenteScreen", initialDateDefault)
      );
      dispatch(
        setFilterAgentDashboard("finalDateAgentScreen", finalDateDefault)
      );
      dispatch(
        setFilterAgentDashboard("initialDateYear", subYears(new Date(), 1))
      );
      dispatch(setFilterAgentDashboard("finalDateYear", new Date()));

      window.localStorage.setItem(
        "agentDashboardFilter",
        JSON.stringify({
          periodSelectedAgentScreen: [{ id: 5, label: "Personalizar" }],
          profileSelectedAgenteScreen: [{ id: "PROMOTOR", label: "Promotor" }],
          channelSelectedAgentScreen: [{ id: 1, label: "Voz" }],
          groupSelectedAgentScreen: [{ id: userReducer.idgroup, label: userReducer.grupo }],
          avaliationSelectedAgentScreen: [{ id: 1, label: "Testando" }],
          initialDateAgenteScreen: initialDateDefault,
          finalDateAgentScreen: finalDateDefault,
          initialDateYear: subYears(new Date(), 1),
          finalDateYear: new Date(),
        })
      );

      others.onClose(false);
      return;
    }

    dispatch(setFilterNps("active", false));
    dispatch(setFilterNps("business", []));
    dispatch(setFilterNps("period", [{ id: 5, label: "Personalizar" }]));
    dispatch(
      setFilterNps("comparison", [{ id: "PROMOTOR", label: "Promotor" }])
    );
    dispatch(setFilterNps("units", []));
    dispatch(setFilterNps("datestart", initialDateDefault));
    dispatch(setFilterNps("dateend", finalDateDefault));

    others.onClose(false);
  };

  const cleanFilters = () => {
    cleanFiltersAdvanceds();
    if (isAgentScreen) {
      setPeriodSelectedAgentScreen([{ id: 5, label: "Personalizar" }]);
      setProfileSelectedAgenteScreen([{ id: "PROMOTOR", label: "Promotor" }]);
      setChannelSelectedAgentScreen([{ id: 1, label: "Voz" }]);
      setGroupSelectedAgentScreen([{ id: userReducer.idgroup, label: userReducer.grupo }]);
      setAvaliationSelectedAgentScreen([]);
      setInitialDateAgenteScreen(initialDateDefault);
      setFinalDateAgentScreen(finalDateDefault);
      setInitialDateYear(subYears(new Date(), 1));
      setFinalDateYear(new Date());

      return;
    }

    setBusinessSelected([]);
    setPeriodSelected([{ id: 5, label: "Personalizar" }]);
    setComparisonSelected([{ id: "PROMOTOR", label: "Promotor" }]);
    setUnitsSelected([]);
    setInitialDate(initialDateDefault);
    setFinalDate(finalDateDefault);
  };

  useEffect(() => {
    //getBusinessList();
    //getUnitsList();
    getChannelsList();
    getAvaliationsList();
  }, []);

  useEffect(() => {
    switch (periodSelected[0].id) {
      case 1:
        setInitialDate(
          new Date(
            finalDate.getFullYear(),
            finalDate.getMonth(),
            finalDate.getDate(),
            0,
            1,
            0,
            0
          )
        );
        setFinalDate(
          new Date(
            finalDate.getFullYear(),
            finalDate.getMonth(),
            finalDate.getDate(),
            23,
            59,
            59,
            999
          )
        );
        break;
      case 2:
        setInitialDate(startOfWeek(finalDate));
        setFinalDate(endOfWeek(finalDate));
        break;
      case 3:
        setInitialDate(startOfMonth(finalDate));
        setFinalDate(endOfMonth(finalDate));
        break;
      case 4:
        setInitialDate(startOfYear(finalDate));
        setFinalDate(endOfYear(finalDate));
        break;
      case 5:
        const updateInitialDateDefault = npsFilters.datestart
          ? new Date(npsFilters.datestart)
          : initialDateDefault;
        const updateFinalDateDefault = npsFilters.dateend
          ? new Date(npsFilters.dateend)
          : finalDateDefault;

        const updateInitialDateComparisons = npsFilters.datestartComparisons
          ? new Date(npsFilters.datestartComparisons)
          : initialDateDefault;

        const updateFinalDateComparisons = npsFilters.dateendComparisons
          ? new Date(npsFilters.dateendComparisons)
          : finalDateDefault;

        const initialYear = getYear(updateInitialDateComparisons);
        const finalYear = getYear(updateFinalDateComparisons);

        if (screen === "Comparisons") {
          if (initialYear === finalYear) {
            const initialDateOneYearAgo = new Date(
              updateInitialDateComparisons
            );
            initialDateOneYearAgo.setFullYear(
              updateInitialDateComparisons.getFullYear() - 1
            );
            setInitialDate(initialDateOneYearAgo);
            setFinalDate(updateFinalDateComparisons);
          } else {
            setInitialDate(updateInitialDateComparisons);
            setFinalDate(updateFinalDateComparisons);
          }
        } else {
          setInitialDate(updateInitialDateDefault);
          setFinalDate(updateFinalDateDefault);
        }
        /*
        if (screen === "Comparisons" || screen === "Rankings") {
          setInitialDate(new Date(npsFilters.datestart));
          setFinalDate(new Date(npsFilters.dateend));
        } else {
          setInitialDate(initialDateDefault);
          setFinalDate(finalDateDefault);
        }
        */
        break;

      default:
        break;
    }
  }, [periodSelected, screen]);

  useEffect(() => {
    if (
      businessSelected.length === 0 &&
      comparisonSelected.length === 0 &&
      unitsSelected.length === 0
      // &&
      // initialDate.getDate() === initialDateDefault.getDate() &&
      // finalDate.getDate() === finalDateDefault.getDate()
    ) {
      setControlActive(false);
    } else {
      setControlActive(true);
    }
  }, [
    businessSelected.length,
    periodSelected.length,
    comparisonSelected.length,
    unitsSelected.length,
    initialDate,
    finalDate,
  ]);

  useEffect(() => {
    window.localStorage.setItem("npsFilters", JSON.stringify(npsFilters));
  }, [npsFilters]);

  useEffect(() => {
    if (screen !== "Dashboard") {
      changeOptionsPeriod({ id: 5, label: "Personalizar" });
    }
  }, [screen]);

  return (
    <Drawer.Main
      title="Filtros"
      isOpen={others.isOpen}
      onClose={() => {
        setInitialDate(new Date(npsFilters.datestart));
        setFinalDate(new Date(npsFilters.dateend));
        setBusinessSelected(npsFilters.business);
        setPeriodSelected(npsFilters.period);
        setComparisonSelected(npsFilters.comparison);
        setUnitsSelected(npsFilters.units);
        setPeriodSelectedAgentScreen(
          agentDashboardFilter.periodSelectedAgentScreen
        );
        setProfileSelectedAgenteScreen(
          agentDashboardFilter.profileSelectedAgenteScreen
        );
        setChannelSelectedAgentScreen(
          agentDashboardFilter.channelSelectedAgentScreen
        );
        setAvaliationSelectedAgentScreen(
          agentDashboardFilter.avaliationSelectedAgentScreen
        );
        setInitialDateAgenteScreen(
          new Date(agentDashboardFilter.initialDateAgenteScreen)
        );
        setFinalDateAgentScreen(
          new Date(agentDashboardFilter.finalDateAgentScreen)
        );
        setInitialDateYear(new Date(agentDashboardFilter.initialDateYear));
        setFinalDateYear(new Date(agentDashboardFilter.finalDateYear));
        /*
  const [controlActive, setControlActive] = useState(false);
  const [listChannel, setListChannel] = useState([]);
  const [listAvaliations, setListAvaliations] = useState([]);
        */
        return others.onClose(false);
      }}
      className="dashboard-height"
    >
      <div
        className={`filters-dashboard-container filters-dashboard-container-call-center`}
      >
        {isAgentScreen ? (
          renderAgentScreeFilters()
        ) : (
          <div className="filters-dashboard">
            <FieldContainer title="Negócio" htmlFor="">
              <div className="filters-dashboard-container-tag">
                <SelectTagV2
                  valueTag={businessSelected}
                  options={businessList}
                  onSelect={(option) => {
                    changeOptionsBusiness(option);
                  }}
                  isCallCenter={true}
                  isCloseOnSelect={false}
                />
              </div>
            </FieldContainer>
            {screen === "Dashboard" && (
              <FieldContainer title="Selecione o período" htmlFor="">
                <div className="filters-dashboard-container-tag">
                  <SelectTagV2
                    valueTag={periodSelected}
                    options={listRequest}
                    onSelect={(option) => {
                      changeOptionsPeriod(option);
                    }}
                    multiple={false}
                    isCallCenter={true}
                  />
                </div>
              </FieldContainer>
            )}
            <div className="filters-dashboard-container__date-range-container">
              {changeDateInput(periodSelected[0].id)}
            </div>
            <FieldContainer title="Unidades" htmlFor="">
              <div className="filters-dashboard-container-tag">
                <SelectTagV2
                  valueTag={unitsSelected}
                  options={unitsList}
                  onSelect={(option) => {
                    changeOptionsUnits(option);
                  }}
                  isCallCenter={true}
                  isCloseOnSelect={false}
                />
              </div>
            </FieldContainer>
            {screen === "Comparisons" && (
              <FieldContainer title="Perfil" htmlFor="">
                <div className="filters-dashboard-container-tag">
                  <SelectTagV2
                    valueTag={comparisonSelected}
                    options={listComparison}
                    onSelect={(option) => {
                      changeOptionsComparison(option);
                    }}
                    multiple={false}
                    isCallCenter={true}
                  />
                </div>
              </FieldContainer>
            )}
          </div>
        )}
        <div className="filters-dashboard__buttons">
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              cursor: `${!controlActive ? "default" : "pointer"}`,
            }}
            onClick={controlActive ? cleanFilters : null}
          >
            <CleanIcon
              className={`${!controlActive ? "disabled-icon" : "clean-icon"}`}
            />
            <div>
              <Typography.H5
                weight="400"
                color={`${!controlActive ? "gray-125" : "red-2"}`}
              >
                Limpar Filtros
              </Typography.H5>
            </div>
          </div>
          <Button
            className={"buttons-aplyfilters"}
            onClick={getCasesFilterAdvanceds}
          >
            Aplicar Filtros
          </Button>
        </div>
      </div>
    </Drawer.Main>
  );
}
